import { CheckCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import {
  Box,
  Heading,
  Icon,
  Text,
  VStack,
} from '@dotfile/frontend/shared/design-system';

export const SignatureSuccessMessage = () => {
  const { t } = useTranslation();

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      minHeight="400px"
      p="8"
      flex="1"
    >
      <VStack spacing="6" textAlign="center" maxWidth="400px">
        <Icon as={CheckCircle} boxSize="16" color="green.500" />

        <VStack spacing="3">
          <Heading size="lg" color="gray.900">
            {t('checks.electronic_signature.success.title', {
              defaultValue: 'Document Signed Successfully',
              ns: 'client-portal',
            })}
          </Heading>

          <Text color="gray.600" fontSize="md">
            {t('checks.electronic_signature.success.description', {
              defaultValue:
                'Your document has been signed successfully. You can now close this modal.',
              ns: 'client-portal',
            })}
          </Text>
        </VStack>
      </VStack>
    </Box>
  );
};
